<script>
    import {link} from "svelte-spa-router"

    export let data = {
        id: "",
        name: "",
        picture: "",
        manufacturer: "",
        manufacturer_logo: "",

        adhesion: "",
        rolling_resistance: "",
        noise: "",

        season: "",
        width: "",
        profile: "",
        diameter: "",

        price: "",
        oldPrice: null
    }

    function pickColor(value) {
        switch (value) {
            case 'A':
                return '#00A943'
            case 'B':
                return '#51B842'
            case 'C':
                return '#C0D437'
            case 'D':
                return '#FFF000'
            case 'E':
                return '#FFB41C'
            case 'F':
                return '#EC7517'
            case 'G':
                return '#EB1C26'
            default:
                return '#f1f5f9'
        }
    }

    function chooseSeasonImgSrc () {
        switch (data.season) {
            case 'Letní':
                return '/assets/img/icons/sun.svg'
            case 'Zimní':
                return '/assets/img/icons/snowflake.svg'
            case 'Celoroční':
                return '/assets/img/icons/wholeyear.svg'
            default:
                return ''
        }
    }
</script>

<a class="product" href="/produkt/{data.id}" use:link>
    <div class="product-logo">
        {#if data?.manufacturer_logo?.length > 0}
            <img src={data.manufacturer_logo} alt="{data.manufacturer}">
        {:else}
            <span>{data.manufacturer}</span>
        {/if}
    </div>
    <div class="product-name">{data.name}</div>
    <div class="product-body">
        <div class="product-image">
            <img src={(data?.picture?.length > 0)? data.picture : "./assets/img/nahled.webp"} alt="Fotografia pneumatiky">
        </div>
        <div class="product-props">
            <div class="prop-item">
                <div class="item-icon"><i class="fas fa-cloud-rain"></i></div>
                <div class="item-number" style="background-color: {pickColor(data.adhesion)}26; color: {pickColor(data.adhesion)}">{data.adhesion || '-'}</div>
            </div>
            <div class="prop-item">
                <div class="item-icon"><i class="fas fa-gas-pump"></i></div>
                <div class="item-number" style="background-color: {pickColor(data.rolling_resistance)}26; color: {pickColor(data.rolling_resistance)}">{data.rolling_resistance || '-'}</div>
            </div>
            <div class="prop-item">
                <div class="item-icon"><i class="fas fa-wifi fa-rotate-90"></i></div>
                <div class="item-number">{data.noise || '-'}</div>
            </div>
        </div>
    </div>
    <div class="product-footer">
        <div class="product-details">
            {#if data.season && data.season !== 'Unclassified'}
                <img src="{chooseSeasonImgSrc()}" alt="{data.season}">
            {/if}
            <div class="detail-item">{data.width || '-'}</div>
            <div class="detail-item">{data.profile || '-'}</div>
            <div class="detail-item">{data.diameter || '-'}</div>
        </div>
        <div class="product-price">
            <div class="price">
                {#if data.oldPrice > 0}
                    <span class="sale">{data.oldPrice.toFixed(2)}€</span>
                {/if}
                <span>{data.price.toFixed(2)}€</span>
            </div>
        </div>
    </div>
</a>

<style>
    .product {
        display: block;
        color: black;
        text-align: center;
        transition: 0.2s linear;
        margin-bottom: 2rem;
        border-radius: 1.5rem;
        overflow: hidden;
        border: 1px solid var(--color-slate-200);
    }
    .product:hover {
        transform: translateY(-10px);
        border-color: var(--color-slate-400);
    }
    .product .product-logo {
        display: grid;
        place-items: center;
        height: 3rem;
    }
    .product .product-logo img {
        max-width: 8rem;
        max-height: 2rem;
    }
    .product .product-logo span {
        font-family: "Rubik", sans-serif;
        font-weight: 500;
        font-size: 1.5rem;
        margin-top: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .product .product-name {
        font-family: SegoeUI, sans-serif;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0 1rem;
        color: var(--color-slate-600);
    }
    .product .product-body {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        margin: 1.3rem 0;
    }
    .product .product-body .product-image {
        display: grid;
        place-items: center;
        width: 40%;
        height: 9rem;
    }
    .product .product-body .product-image img {
        max-height: 9rem;
        max-width: 100%;
    }
    .product .product-body .product-props {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        place-items: center;
        font-family: "Rubik", sans-serif;
        font-weight: 500;
        width: 40%;
    }
    .product .product-body .product-props .prop-item {
        border: 1px solid rgba(15, 23, 42, .1);
        width: 70%;
        height: 2.7rem;
        border-radius: .25rem;
        display: flex;
        flex-direction: row;
        overflow: hidden;
    }
    .product .product-body .product-props .prop-item .item-icon {
        width: 40%;
        background-color: var(--color-slate-50);
        color: var(--color-slate-500);
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
    }
    .product .product-body .product-props .prop-item .item-icon i {
        margin-left: .25rem;
    }
    .product .product-body .product-props .prop-item .item-icon:after {
        content: "";
        position: absolute;
        top: 0;
        right: -1rem;
        border-top: 1.35rem solid transparent;
        border-bottom: 1.35rem solid transparent;
        border-left: 1rem solid var(--color-slate-50);
    }
    .product .product-body .product-props .prop-item .item-number {
        width: 60%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--color-slate-800);
    }
    .product .product-footer {
        padding: .8rem 0;
        background-color: var(--color-slate-50);
    }
    .product .product-footer .product-price {
        display: flex;
        justify-content: center;
    }
    .product .product-footer .product-price .price {
        color: var(--color-slate-600);
        background-color: var(--color-slate-100);
        padding: 0.5rem .75rem;
        border-radius: .25rem;
        border: 1px solid var(--color-slate-200);
        font-family: "Rubik", sans-serif;
        font-weight: 600;
        font-size: 1.3rem;
        width: 12rem;
				height: 4rem;
				display: flex;
				flex-direction: column;
				justify-content: center;
    }
		.product .product-footer .product-price .price .sale {
			font-size: 1rem;
			font-weight: 500;
			color: var(--color-slate-400);
			text-decoration: line-through;
		}
    .product .product-footer .product-details {
        display: flex;
        flex-direction: row;
        justify-content: center;
        font-family: "Rubik", sans-serif;
        font-weight: 500;
        margin-bottom: .75rem;
    }
    .product .product-footer .product-details img {
        padding-top: 0.1rem;
    }
    .product .product-footer .product-details div {
        border-right: 2px solid var(--color-slate-200);
        font-size: 1.2rem;
        padding: 0.3rem 1rem;
        color: var(--color-slate-800);
    }
    .product .product-footer .product-details div:last-child {
        border: 0;
    }
</style>